export default{
  layout: {
    color: '',
  },
  modules: {
    'a-login': {
      provider: {
        simple: {
          module: 'a-authsimple',
          component: 'signin',
        },
        buttons: {
          github: false,
        },
      },
    },
    // "a-layoutpc" : {
    //   layout : {
    //     login: '/iotcabinet/base/web/login',
    //   }
    // },
    // "a-layoutmobile" : {
    //   layout : {
    //     login: '/iotcabinet/base/web/login',
    //   }
    // },
    'a-components': {
      validate: {
        hint: {
          optional: '可选',
          must: '',
        },
      },
    },
  },
};
